if (!customElements.get('pdp-gallery')) {
  class PdpGallery extends HTMLElement {
    connectedCallback() {
      this._mq = window.matchMedia('(min-width: 990px)');
      this._thumbsSwiper = null;
      this._mainSwiper = null;
      this._mqHandler = () => { this._destroy(); this._init(); };
      this._enableYouTubeApi();
      this._init();
      this._mq.addEventListener('change', this._mqHandler);
    }

    disconnectedCallback() {
      this._mq.removeEventListener('change', this._mqHandler);
      this._destroy();
    }

    _destroy() {
      if (this._thumbsSwiper) { this._thumbsSwiper.destroy(true, true); this._thumbsSwiper = null; }
      if (this._mainSwiper) { this._mainSwiper.destroy(true, true); this._mainSwiper = null; }
    }

    _enableYouTubeApi() {
      this.querySelectorAll('.pdp-gallery__main iframe[src*="youtube"]').forEach(iframe => {
        try {
          const url = new URL(iframe.src);
          url.searchParams.set('enablejsapi', '1');
          iframe.src = url.toString();
        } catch (_) {}
      });
    }

    _pauseAllMedia() {
      this.querySelectorAll('.pdp-gallery__main video').forEach(v => v.pause());
      this.querySelectorAll('.pdp-gallery__main iframe[src*="youtube"]').forEach(iframe => {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
    }

    setActiveMedia(mediaId) {
      if (!this._mainSwiper) return;
      const slides = this._mainSwiper.slides;
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === mediaId) {
          this._mainSwiper.slideTo(i);
          break;
        }
      }
    }

    _init() {
      const id = this.dataset.sectionId;
      const isDesktop = this._mq.matches;

      this._thumbsSwiper = new Swiper(`#pdp-thumbs-${id}`, {
        direction: isDesktop ? 'vertical' : 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 6,
        watchSlidesProgress: true,
        navigation: isDesktop ? {
          prevEl: `#pdp-thumbs-prev-${id}`,
          nextEl: `#pdp-thumbs-next-${id}`,
        } : false,
      });

      this._mainSwiper = new Swiper(`#pdp-main-${id}`, {
        slidesPerView: 1,
        keyboard: { enabled: true },
        navigation: {
          nextEl: `#pdp-main-${id} .swiper-button-next`,
          prevEl: `#pdp-main-${id} .swiper-button-prev`,
        },
        thumbs: { swiper: this._thumbsSwiper },
        on: {
          slideChange: () => this._pauseAllMedia(),
        },
      });
    }
  }
  customElements.define('pdp-gallery', PdpGallery);
}
